import api from "../../../../lib/api";
import { ChangeCustomerUserPassword, ICustomerUserCreate, ICustomerUserListSearch, IEditCustomerUserPayload } from "../../../../types/customerUserInterface"

export const createCustomerUserApi = async (data: ICustomerUserCreate) => {
  return await api.post(`/customer-users`, data);
};

export const getCustomerUserListApi = async (data: ICustomerUserListSearch) => {
  return await api.get(`/customer-users/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getCustomerUserDataByIdApi = async (id: number) => {
  return await api.get(`/customer-users/${id}`)
}
 
export const editCustomerUserDataByIdApi = async (payload: IEditCustomerUserPayload) => {
  return await api.put(`/customer-users/${payload.id}`, payload.data);
};
  
// soft delete on the backend
export const deleteCustomerUserApi = async (id: number) => {
  return await api.delete(`/customer-users/${id}`)
}

export const changeCustomerUserPasswordApi = async (data: ChangeCustomerUserPassword) => {
  return await api.post(`/customer-users/change-password/${data.customerUserId}`, data.payload)
}